import { useMemo, useState } from 'react'

export const useListaFiltros = (lista, campoNombre = 'nombre') => {
  const [ordenNombre, setOrdenNombre] = useState(null)
  const [busqueda, setBusqueda] = useState('')
  const [terminoBusqueda, setTerminoBusqueda] = useState('')
  const [ordenVencimiento, setOrdenVencimiento] = useState(false)

  const ordenarLista = (items, orden, porVencimiento) => {
    if (porVencimiento) {
      return [...items].sort((a, b) => new Date(a.vigenciaHasta) - new Date(b.vigenciaHasta))
    }
    if (!orden) return items
    return [...items].sort((a, b) => {
      const va = (a[campoNombre] ?? '').toLowerCase()
      const vb = (b[campoNombre] ?? '').toLowerCase()
      if (va < vb) return orden === 'asc' ? -1 : 1
      if (va > vb) return orden === 'asc' ? 1 : -1
      return 0
    })
  }

  const listaFiltradaOrdenada = useMemo(() => {
    const filtrada = terminoBusqueda
      ? lista.filter((item) => (item[campoNombre] ?? '').toLowerCase().includes(terminoBusqueda))
      : lista
    return ordenarLista(filtrada, ordenNombre, ordenVencimiento)
  }, [lista, terminoBusqueda, ordenNombre, ordenVencimiento, campoNombre])

  const handleBusqueda = (valor) => setTerminoBusqueda(valor)

  const handleOrdenarAZ = (orden) => {
    setOrdenNombre(orden)
    setOrdenVencimiento(false)
  }

  const handleOrdenarPorVencimiento = () => {
    setOrdenVencimiento(true)
    setOrdenNombre(null)
  }

  return {
    listaFiltradaOrdenada,
    busqueda,
    setBusqueda,
    handleBusqueda,
    handleOrdenarAZ,
    handleOrdenarPorVencimiento
  }
}
